import { SiteFiltersStore } from "../store";

export function updateAssignees(assignees: string[], store: SiteFiltersStore) {
  store.assignees = assignees;
}
